import axios from './httpConfig.js'
//******************客户管理 -- 客户管理 ******************/
// 客户列表
export function GetCustomerList(param) {
	return axios.post('/admin/customer/list', param)
}

// 新增客户
export function AddCustomer(param) {
	return axios.post('/admin/customer/add', param)
} 

// 删除客户
export function DeleteCustomer(param) {
	return axios.post('/admin/customer/delete', param)
}

// 修改客户
export function EditCustomer(param) {
	return axios.post('/admin/customer/edit', param)
} 

// 禁用客户
export function DisabledCustomer(param) {
	return axios.post('/admin/customer/disabled', param)
}